import { Avatar, Flex, Text } from '@chakra-ui/react';
import { useOrgIdWithRel } from 'hooks/useOrgIdWithRel';
import React, { useMemo } from 'react';
import { getFirstChar } from 'utils';

interface OrganizationOptionItemProps {
    item: {
        value: string;
        label: string;
    };
    handleChooseOrg: (orgId: string) => void;
}

const OrganizationOptionItem = (
    { item, handleChooseOrg }: OrganizationOptionItemProps
) => {
    const { selectedOrgIdWithRelName } = useOrgIdWithRel();

    const isSelected = useMemo(() => selectedOrgIdWithRelName === item.label, [selectedOrgIdWithRelName, item.label]);

    return (
        <Flex
            key={item.value}
            gap="15px"
            _hover={{ cursor: "pointer", backgroundColor: "gray.100" }}
            _active={{ backgroundColor: "gray.50" }}
            alignItems="center"
            transition={"all 0.2s ease-in-out"}
            borderRadius="5px"
            p="10px"
            userSelect="none"
            pr="20px"
            border="1px solid var(--chakra-colors-gray-200)"
            onClick={() => handleChooseOrg(item.value)}
            data-testid="choose-organization"
            as="button"
            disabled={isSelected}
            _disabled={{
                opacity: 0.6,
                cursor: "not-allowed",
                backgroundColor: "gray.50",
            }}
        >
            <Avatar
                size="md"
                bg="#EBEBEB"
                name={getFirstChar(item.label)}
                textColor="black"
            />
            <Text>{item.label}</Text>
        </Flex>
    );
};

export default OrganizationOptionItem;